import axios from 'axios'
import * as accessTokenInfo from "../../accessToken";
import router from '../../../router'

export const fetchCustomerMasterList = ({commit}, payload) => {
    
    commit('toggleLoadingState', true)
    axios.post('/customerMaster/index.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        commit('setCustomerMasterList', {response: res.data.response, total: res.data.total, page_number: res.data.page_number, page_number: res.data.page_number})
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })

}

export const fetchCustomerOrderList = ({commit}, payload) => {
    
    commit('toggleLoadingState', true)
    axios.post('/customerMaster/fetchCustomerOrderList.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        commit('setCustomerMasterOrderList', res.data.response)
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const checkCustomerMobileExists = ({commit}, payload) => {
    
    commit('toggleLoadingState', true)
    axios.post('/customerMaster/checkCustomerMobileExists.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        console.log(JSON.stringify(res.data));
        if(res.data.status) {
            commit('displayMessageAlert', {message: res.data.message, type: 'Warning'})    
        } else {
            commit('displaySuccessNotification', {message: 'Mobile number is unique'});
        }
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const checkCustomerEmailExists = ({commit}, payload) => {
    
    commit('toggleLoadingState', true)
    axios.post('/customerMaster/checkCustomerEmailExists.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        if(res.data.status) {
            commit('displayMessageAlert', {message: res.data.message, type: 'Warning'})    
        } else {
            commit('displaySuccessNotification', {message: 'Email address is unique'});
        }
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const loadCustomerStatement = ({commit}, payload) => {

    commit('toggleLoadingState', true)

    axios.post('/customerMaster/statement.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        commit('setCustomerMasterStatementList', res.data.response)
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const fetchCustomerMasterAutocompleteList = ({commit}, payload) => {

    commit('toggleLoadingState', true)
    axios.post('/customerMaster/autocomplete.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {

        commit('setCustomerMasterAutocompleteList', res.data.response)         
        if(payload.load_delivery_receipt) {
            setTimeout(() => {
                router.push('/deliveryreceipts/form/')        
            }, 400);            
        }
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const fetchCustomerMasterMeasurementData = ({commit}, payload) => {
    commit('toggleLoadingState', true)
    commit('setLoadingMeasurements')
    axios.post('/customerMaster/fetchMeasurementData_1.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {

        if(res.data.status) {
            commit('setCustomerMasterMeasurementData', res.data.response)              
        } else {
            commit('resetCustomerMasterMeasurementData')   
        }
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const fetchCustomerMasterData = ({commit, dispatch}, payload) => {
    commit('toggleLoadingState', true)
    axios.post('/customerMaster/single.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {

        if(res.data.status) {
            commit('setCustomerMasterData', {response: res.data.response, copy: payload.copy})   
            
            setTimeout(() => {
                if(payload.fetchMsmt) {
                    dispatch('fetchCustomerMasterMeasurementData', payload)
                }
                
                if(payload.navigate) {
                    router.push(router.currentRoute.fullPath+'/form/')
                }
                if(payload.navigateSale) {
                    router.push('/salesorders/form')  
                }
                
                dispatch('loadProvinceList', res.data.response.country_id)
                dispatch('loadCityList', res.data.response.province_id)                
            }, 300);
            
        } else {
            commit('resetCustomerMasterData')
        }
        

    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        
    })
}

export const submitCustomerMasterData = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
    if(payload.id>0) {
        setTimeout(() => {
            //commit('displaySuccessNotification', {message: 'Data submitted successfully!!!'});
            //commit('toggleLoadingState', false)
        }, 2000);        
    }    
    axios.post('/customerMaster/save.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {    
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data submitted successfully!!!'});
            if(payload.id > 0) {
                //dispatch('fetchCustomerMasterMeasurementData', {id: res.data.id})
                dispatch('fetchCustomerMasterData', {id: res.data.id, fetchMsmt: true})
            } else {
                dispatch('fetchCustomerMasterData', {id: res.data.id, fetchMsmt: false})
            }
        } else {
            commit('displayMessageAlert', {message: res.data.message, type: 'Error', displayHTML: true});            
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const emailCustomerList = ({commit}, payload) => {
    
    commit('toggleLoadingState', true)
    setTimeout(() => {
        commit('displayMessageAlert', {message: 'Admin will receive an email in a few minutes.', type: 'Info'})
        commit('toggleLoadingState', false)
    }, 1000);
    axios.post('/customerMaster/emailCustomerList.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => { 
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const deleteCustomerMasterData = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/customerMaster/delete.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data deleted successfully!!!'});
            if(payload.navBack) {
                router.push(router.currentRoute.fullPath.replace('/form/', ''))
            } else {
                dispatch('fetchCustomerMasterList', payload.list)
            }
            
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const fetchCustomerDD = ({commit}) => {

    commit('toggleLoadingState', true)
            
    axios.get('/customerMaster/downloadDD.php', accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        commit('setCustomerDD', res.data)
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const submitCustomerDD = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/customerMaster/saveDD.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data submitted successfully!!!'});    
            dispatch('fetchCustomerDD')
        } else {
            commit('displayMessageAlert', {message: 'Error while saving', type: 'Error', displayHTML: true});            
        }        
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const prepareCustomerImportSheet = ({commit}, payload) => {

    commit('toggleLoadingState', true)
    axios.post('/exportModule/customer/prepareSheet.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        if(res.data.status) {
            if(payload.campaign) {
                commit('setCampaignCustomerList', res.data.response)
            } else {
                commit('setCustomerMasterImportListRow', res.data.response)
            }
            
            setTimeout(() => {
                commit('toggleLoadingState', false)
            }, 2000);
        } else {
            commit('displayMessageAlert', {message: res.data.message, type: 'Error'})
            commit('toggleLoadingState', false)
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        
    })
}

export const submitImportCustomerListData = ({commit}, payload) => {

    commit('toggleLoadingState', true)

    axios.post('/exportModule/customer/submitData.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        commit('displaySuccessNotification', {message: 'Data submitted successfully!!!'});
        commit('resetCustomerMasterImportList', res.data)
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}


// WEBPACK FOOTER //
// ./src/store/modules/customerMaster/actions.js